var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOneDrive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 27 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M23.797 10.534a2.96 2.96 0 0 1 .652 5.668H9.607a3.43 3.43 0 1 1 .305-6.848 4.293 4.293 0 0 1 8.105-2.22 3.742 3.742 0 0 1 5.78 3.4M9.167 8.608a4.195 4.195 0 0 0-3.727 4.164c0 .877.273 1.693.738 2.367H3.849a3.552 3.552 0 0 1-.258-7.094 4 4 0 0 1 6.14-4.181 5.529 5.529 0 0 1 10.453 1.902l-.118-.003c-.616 0-1.219.125-1.777.365a5.03 5.03 0 0 0-4.093-2.09 5.06 5.06 0 0 0-5.03 4.57",
  clipRule: "evenodd"
})));
export default SvgOneDrive;